import styled from 'styled-components';
import {
  flex,
  flexDirection,
  FlexDirectionProps,
  gridGap,
  GridProps,
  justifyContent,
  JustifyContentProps,
  layout,
  LayoutProps,
  padding,
  PaddingProps,
} from 'styled-system';

export const StyledTableHeader = styled.div<JustifyContentProps & LayoutProps>`
  flex: 1;
  display: flex;
  ${layout};
  ${justifyContent};
`;
StyledTableHeader.defaultProps = {
  minWidth: 120,
};

export const TableHeadContainer = styled.div<
  JustifyContentProps &
    LayoutProps &
    FlexDirectionProps &
    PaddingProps &
    GridProps
>`
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-weight: inherit;
  display: inline-flex;
  ${flexDirection};
  ${layout};
  ${padding};
  ${gridGap};
  ${flex};
`;
TableHeadContainer.defaultProps = {
  gridGap: 3,
  paddingY: 6,
  paddingX: 2,
};
